export default "__VITE_ASSET__DNB3tNQd__"